// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__acTKJ","label":"Completed_label__1-AAA"};